/**
 * Shared host-gate for analytics SDKs (currently Plausible).
 *
 * Analytics MUST only initialize on real production hosts. Every other
 * environment — localhost, Lovable preview (`*.lovable.app`,
 * `*.lovableproject.com`, `id-preview--*`), staging, IP literals — is a
 * hard no-op so test traffic never pollutes production dashboards.
 */


const PRODUCTION_HOSTS: ReadonlySet<string> = new Set([
  "excerptus.io",
  "www.excerptus.io",
]);

export const isProductionAnalyticsHost = (): boolean => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  return PRODUCTION_HOSTS.has(host);
};
